export const createGaEvent = (gaEvent) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: gaEvent.event || 'AutoEvent',
            eventCategory: gaEvent.eventCategory,
            eventAction: gaEvent.eventAction,
            eventLabel: gaEvent.eventLabel
        });
    }
};
